import { useEffect, useState } from 'react'
import styles from './PurchaseParkingPage.module.css'
import { useParking } from '../ParkingCardPage/ParkingContext'
import { useNavigate } from 'react-router-dom'
import { MAIN_PAGE, PARKING_PAGE } from '../../router/paths'
import InternalHeader from '../../components/InternalHeader/InternalHeader'
import PurchaseParkingPageStageOne from './PurchaseParkingPageStages/PurchaseParkingPageStageOne/PurchaseParkingPageStageOne'
import PurchaseParkingPageStageTwo from './PurchaseParkingPageStages/PurchaseParkingPageStageTwo/PurchaseParkingPageStageTwo'
import PurchaseParkingPageStageThree from './PurchaseParkingPageStages/PurchaseParkingPageStageThree/PurchaseParkingPageStageThree'

export default function PurchaseParkingPage() {
  const navigate = useNavigate()
  const { parking, selectedOption } = useParking()
  const [currentStage, setCurrentStage] = useState(0);

  useEffect(() => {
    if (!parking) {
      navigate(MAIN_PAGE)
    }
  }, [parking, navigate])

  const stages = ['1', '2', '3'];

  const handleNextStage = () => {
    if (currentStage < stages.length - 1) {
      setCurrentStage(currentStage + 1);
    }
  };

  if (!parking) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <InternalHeader 
        title='Бронирование' 
        onClose={() => navigate(PARKING_PAGE.replace(':id', parking.id.toString()))} 
      />
      
      <div className={styles.content_wrapper}>
        <div className={styles.content}>
          {currentStage === 0 && (
              <PurchaseParkingPageStageOne
                  selectedOption={selectedOption}
                  parking={parking}
                  handleNextStage={handleNextStage}
              />
          )}
          {currentStage === 1 && (
              <PurchaseParkingPageStageTwo
                  handleNextStage={handleNextStage}
              />
          )}
          {currentStage === 2 && (
              <PurchaseParkingPageStageThree />
          )}
        </div>
      </div>
    </div>
  )
}
